import {useAsset} from "../../../AssetHelper";

import {DecodeScoreDetail} from "../../../javaTypes";
import ScorePill from "../ScorePill";
import robotSvg from '@fortawesome/fontawesome-free/svgs/solid/robot.svg'
import arrowRight from '@fortawesome/fontawesome-free/svgs/solid/arrow-right.svg'

import './Score.css'
import {ReactSVG} from "react-svg";
import DisplayParams from "../../DisplayParams";
import {useContext} from "react";

export default function Score({score, color, right, isSingleTeam, isAuto, isPlayoff} : {
    score: Partial<DecodeScoreDetail>,
    color: 'red' | 'blue' | 'orange',
    right?: boolean,
    isSingleTeam?: boolean,
    isAuto?: boolean,
    isPlayoff?: boolean,
}) {
    const displayParams = useContext(DisplayParams);
    const artifactSvg = useAsset('img/decode/artifact-white.svg');
    const values = displayParams.keyScoreValues;
    return <div className={`scoreSection ${right ? 'right' : ''} ${isSingleTeam ? 'singleTeam' : ''}`}>
        {isAuto ? null : <div className={"d-flex flex-column"}>
            <ScorePill icon={robotSvg} value={<span>
                <i className={`fa fa-fw ${score.robot1Auto ? 'fa-check' : 'fa-times'}`}></i>
                <i className={`fa fa-fw ${score.robot2Auto ? 'fa-check' : 'fa-times'}`}></i>
            </span>} />
            <ScorePill className={"mt-3"} icon={<div className={"motif"}>
                <ReactSVG src={artifactSvg} />
                <ReactSVG src={artifactSvg} />
                <ReactSVG src={artifactSvg} />
            </div>} value={(score.autoPatternPoints || 0) / (values?.autoMotifMatchValue ?? 2)} />
        </div>}
        <ScorePill icon={<div className={"d-flex flex-column w-100 h-100 justify-content-center align-items-center"}>
            <div className={`svgWrapper fontAwesome`}>
                <ReactSVG src={arrowRight} />
            </div>
            <div className={`svgWrapper`}>
                <ReactSVG src={artifactSvg} />
            </div>
        </div>} value={[
            Math.max(0, (score.autoOverflowArtifacts || 0) + (score.teleopOverflowArtifacts || 0)),
            Math.max(0, (score.autoClassifiedArtifacts || 0) + (score.teleopClassifiedArtifacts || 0)),
        ]} goal={isPlayoff ? undefined : (values?.goalRpThreshold ?? 36)} />
    </div>
}